import Chevron from '~/icons/chevron.svg';
import { ResetButton } from '~/shared/components/Button/ResetButton';
import { breakpoints } from '~/theme/breakpoints';
import styled from '@emotion/styled';

export const StyledSubPageHeader = styled.span(({ theme }) => {
    return {
        ...theme.mixins.useTextStyle('display2'),
        color: theme.colors.black,
        display: 'block',
        padding: '270px 0px 20px 0px',
        marginTop: '-250px',
    };
});

const paginatorGap = 28;
const paginatorGapLg = 36;
const paginatorNavButtonSize = 40;
export const StyledPagination = styled.div({
    position: 'relative',
    zIndex: '10',
    margin: `0 -${paginatorGap / 2}px`,
    width: `calc(100% + ${paginatorGap}px)`,

    [breakpoints.md]: {
        margin: `0 -${paginatorGapLg / 2}px`,
        width: `calc(100% + ${paginatorGapLg}px)`,
    },
});

export const StyledPaginatorCarousel = styled.div({
    width: '100%',
    borderRadius: paginatorNavButtonSize,
    overflow: 'hidden',
});

export const StyledPaginator = styled.span(() => ({
    display: 'block',
    padding: `0 ${paginatorGap / 2}px`,
    cursor: 'pointer',

    [breakpoints.md]: {
        padding: `0 ${paginatorGapLg / 2}px`,
    },

    span: {
        display: 'block',
        padding: '8px 0',
    },
}));

export const StyledPaginatorActive = styled(StyledPaginator)(({ theme }) => ({
    span: {
        borderBottom: `2px solid ${theme.colors.black}`,
    },
}));

export const StyledPaginatorNavIcon = styled(Chevron)``;

export const StyledPaginatorNavButton = styled(ResetButton)<{ position: 'left' | 'right' }>(
    ({ theme, position }) => ({
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        position: 'absolute',
        zIndex: 2,
        top: '50%',
        right: position === 'left' ? '' : 0,
        left: position === 'left' ? 0 : '',
        width: paginatorNavButtonSize,
        height: paginatorNavButtonSize,
        borderRadius: paginatorNavButtonSize,
        boxShadow: '0 0px 10px rgba(0,0,0,0.3)',
        backgroundColor: theme.colors.white,
        transform: 'translateY(-50%)',

        '&:disabled': {
            display: 'none',
        },

        [`${StyledPaginatorNavIcon}`]: {
            transform: `rotate(${position === 'left' ? '180deg' : '0deg'})`,
        },
    }),
);

export const StyledBrandLink = styled.button(({ theme }) => ({
    paddingLeft: '0px',
    cursor: 'pointer',
    border: 'none',
    backgroundColor: theme.colors.white,
    lineHeight: '24px',
    textAlign: 'left',
    color: theme.colors.black,
}));
